module.exports = __webpack_public_path__ + "img/grayB.13298f6b.png";